import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";

export default {
  loadUserProfile: () => request(METHODS.GET, API.USER.GET_USER_INFO)(),
};
